import { lazyShowEditorSettings } from '../index';
import { EditorViewState } from 'owa-editor';

export default function getOnClickCallbackForProofingSettings(
    viewState: EditorViewState,
    targetWindow: Window
): () => void {
    return () => {
        lazyShowEditorSettings
            .import()
            .then(showEditorSettings => showEditorSettings(viewState, targetWindow));
    };
}
